import React from "react";
import "../../assets/scss/components/templates/pagination.scss";

const Pagination = ({
  totalPages,
  setCurrentPage,
  currentPage,
  isBackwardDisabled,
  isForwardDisabled,
  onPageChange,
}) => {
  let pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  return (
    <div className="pagination">
      <button
        className={"btn-nav left-btn "}
        onClick={() => {
          if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            onPageChange(currentPage - 1);
          }
        }}
        disabled={!isBackwardDisabled}
      >
        <svg
          width="30"
          height="30"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M35.4684 16.6057L25.5928 26.5029L35.4684 36.4001L32.4281 39.4404L19.4906 26.5029L32.4281 13.5654L35.4684 16.6057Z"
            fill="#000"
          />
        </svg>
      </button>
      <div className="page-numbers">
        {pages.map((pageNumber, index) => (
          <button
            key={index}
            onClick={() => {
              setCurrentPage(pageNumber);
              onPageChange(pageNumber);
            }}
            className={
              currentPage == pageNumber ? "btn-page btn-selected" : "btn-page"
            }
          >
            {pageNumber}
          </button>
        ))}
      </div>
      <button
        className="btn-nav right-btn"
        onClick={() => {
          if (currentPage < pages.length) {
            setCurrentPage(currentPage + 1);
            onPageChange(currentPage + 1);
          }
        }}
        disabled={!isForwardDisabled}
      >
        <svg
          width="30"
          height="30"
          viewBox="0 0 52 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.0256 16.6067L26.9013 26.5039L17.0256 36.4011L20.0659 39.4414L33.0034 26.5039L20.0659 13.5664L17.0256 16.6067Z"
            fill="#000"
          />
        </svg>
      </button>
    </div>
  );
};

export default Pagination;
